export default __webpack_public_path__ + "static/media/nfz-video.003c535d.mp4";